import { render, staticRenderFns } from "./base-slider.vue?vue&type=template&id=9fa4205c&scoped=true&"
import script from "./base-slider.vue?vue&type=script&lang=js&"
export * from "./base-slider.vue?vue&type=script&lang=js&"
import style0 from "./base-slider.vue?vue&type=style&index=0&id=9fa4205c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa4205c",
  null
  
)

export default component.exports